const _ = require("lodash");
const moment = require("moment");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {ErrorBoundary} = require("react-error-boundary");
const StringUtil = require("../../../shared/StringUtil");
const ArrowIcon = require("./ArrowIcon");
const DropdownSelect = require("./DropdownSelect");
const LeaderboardsRankings = require("./LeaderboardsRankings");
const MessageModal = require("./MessageModal");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const ReactPageTrainerError = require("./ReactPageTrainerError");
const AssetsUtil = require("../util/AssetsUtil");
const {
	LeaderboardsMetricHelpModal,
} = require("../util/components/LeaderboardsMetricHelpModal");
const ErrorUtil = require("../../../shared/ErrorUtil");
const Sounds = require("../util/Sounds");
const {
	LUMEN_SCHOOL_ID,
	VIRTUAL_CAMPUS_SCHOOL_ID,
} = require("../../../shared/Constants");
const activeGrades = require("../../../shared/data/dbGradeChapterBlock.json")
	.activeGrades;
const academies = require("../../../shared/data/dbAcademies.json");
const styles = require("./styles/LeaderboardsModal.css");

const activeGradeValues = _.map(activeGrades, g => `Level ${g}`);
const activeGradeOptions = _.zipObject(activeGrades, activeGradeValues);

const metricOrder = ["totalXp", "totalTrophies", "newLevelReached"];
const metricTimeWindows = {
	totalXp: ["OneDay", "OneWeek", "OneMonth"],
	totalTrophies: ["OneMonth", "SixMonths"],
	newLevelReached: ["OneDay", "OneWeek", "OneMonth"],
};

module.exports = createReactClass({
	displayName: "LeaderboardsModalView",

	propTypes: {
		user: PT.object.isRequired,
		onClose: PT.func.isRequired,
		isAcademyUser: PT.bool.isRequired,
	},

	getInitialState: function() {
		const {user, isAcademyUser} = this.props;
		let campus = "all";
		let level = "2";
		let academyOptions = {};
		let academySortedOptionKeys = [];
		// Default campus dropdown to an Academy school the user is in.
		if (isAcademyUser) {
			const academyData = _.mapValues(academies, a => a.displayName);
			// TODO: We are temporarily removing Lumen and Virtual Campus from the campus
			// dropdown. Can remove these delete lines as we add them in.
			delete academyData[LUMEN_SCHOOL_ID];
			delete academyData[VIRTUAL_CAMPUS_SCHOOL_ID];
			// Get an array of ints of the school IDs for Academies.
			const academySchoolIDInts = _.map(_.keys(academyData), i => parseInt(i));

			const studentSchoolIDs = _.get(user, "model.schoolIDs", []);
			const staffSchoolIDs = _.map(
				_.keys(_.get(user, "model.staffSchools", {})),
				i => parseInt(i)
			);
			const schoolIDs = _.concat(studentSchoolIDs, staffSchoolIDs);
			// This is an array of ints of the user's Academy school IDs
			const userAcademySchoolIDs = _.intersection(
				academySchoolIDInts,
				schoolIDs
			);
			if (userAcademySchoolIDs.length) {
				// Default the campus in the dropdown to one of their campuses
				campus = userAcademySchoolIDs[0].toString();
				// The options in their dropdown are only the academies they are in
				academyOptions = _.fromPairs(
					_.map(userAcademySchoolIDs, schoolID => [
						schoolID,
						academyData[schoolID],
					])
				);
				academySortedOptionKeys = _.map(
					_.sortBy(_.toPairs(academyOptions), 1),
					0
				);
			}

			academyOptions.all = "All Campuses";
			academySortedOptionKeys.unshift("all");

			level = _.get(user, "model.academyLeaderboardsGradeID", 2).toString();
		}
		return {
			metric: "totalXp",
			usernameFilter: "all",
			level,
			campus,
			timeWindow: "OneDay",
			isMetricHelpModalOpen: false,
			academyOptions,
			academySortedOptionKeys,
		};
	},

	// Family leaderboards data is stored in the vault keyed by date.
	// This returns a YYYY-MM-DD formatted date string that considers the current time,
	// and tells us what date to check in the vault when fetching leaderboards data.
	// Leaderboards are refreshed at 10 AM UTC. If we're past 10:30 AM in UTC,
	// we return the current day in UTC. If we're before 10:30 AM UTC, we return the
	// previous day in UTC.
	//
	// Note that Academy leaderboards data is less computationally intensive and
	// can be loaded each time the page is refreshed, so we don't need to encode this
	// date into the vault path.
	getCurrentLeaderboardsDate: function() {
		const now = moment.utc();
		const dayUTC = now.format("YYYY-MM-DD");
		const timeLeaderboardsRefreshed = moment
			.utc(`${dayUTC}T10:30:00Z`)
			.format();
		if (now.isAfter(timeLeaderboardsRefreshed)) {
			return dayUTC;
		} else {
			return moment(dayUTC)
				.subtract(1, "d")
				.format("YYYY-MM-DD");
		}
	},

	onClose: function() {
		this.props.onClose();
	},

	changeMetric: function(changeToNext) {
		const {metric} = this.state;
		const currentIndex = metricOrder.indexOf(metric);
		let newIndex;
		if (changeToNext) {
			newIndex = (currentIndex + 1) % metricOrder.length;
		} else {
			newIndex = (currentIndex + 2) % metricOrder.length;
		}
		const newMetric = metricOrder[newIndex];
		const soundName = changeToNext ? "arrow-right" : "arrow-left";
		Sounds.playSound(soundName);
		this.setState({
			metric: newMetric,
			timeWindow: metricTimeWindows[newMetric][0],
		});
	},

	openMetricHelpModal: function() {
		Sounds.playSound("top-bar-icon-3");
		this.setState({
			isMetricHelpModalOpen: true,
		});
	},

	closeMetricHelpModal: function() {
		this.setState({
			isMetricHelpModalOpen: false,
		});
	},

	renderMetricNavigator: function() {
		const {isAcademyUser} = this.props;
		const {metric} = this.state;
		let metricText;
		if (metric === "totalXp") {
			metricText = "XP Earned";
		} else if (metric === "totalTrophies") {
			metricText = "Trophies Earned";
		} else if (metric === "newLevelReached") {
			metricText = "New Levels Earned";
		}

		const nextArrow = isAcademyUser ? null : (
			<div onClick={() => this.changeMetric(true)}>
				<ArrowIcon
					colorName={"white"}
					direction="right"
					type="filled"
					size={1}
					useWonkyCursor={true}
				/>
			</div>
		);
		const prevArrow = isAcademyUser ? null : (
			<div onClick={() => this.changeMetric(false)}>
				<ArrowIcon
					colorName={"white"}
					direction="left"
					type="filled"
					size={1}
					useWonkyCursor={true}
				/>
			</div>
		);

		return (
			<div className={styles.metricNavContainer}>
				<img
					onClick={this.openMetricHelpModal}
					className={styles.metricHelpIcon}
					src={AssetsUtil.getButton("help", "white")}
				/>
				{prevArrow}
				<div className={styles.metricText}>{metricText}</div>
				{nextArrow}
			</div>
		);
	},

	updateUsernameFilter: function(newFilter) {
		this.setState({
			usernameFilter: newFilter,
		});
	},

	updateLevel: function(newLevel) {
		this.setState({
			level: newLevel,
		});
	},

	updateCampus: function(newCampus) {
		this.setState({
			campus: newCampus,
		});
	},

	updateTimeWindow: function(newTimeWindow) {
		this.setState({
			timeWindow: newTimeWindow,
		});
	},

	renderUsernameFilterDropdown: function() {
		const {usernameFilter} = this.state;
		const username = _.get(this.props.user, "model.username") || "HappySloth47";
		const usernamePieces = StringUtil.getUsernamePieces(username);
		const options = {
			all: "All Beasts",
			adjective: `${usernamePieces.adjective} Beasts`,
			animal: `${usernamePieces.animal} Beasts`,
			number: `#${usernamePieces.number} Beasts`,
		};
		return (
			<DropdownSelect
				className={styles.dropdown}
				initialValue={usernameFilter}
				options={options}
				updateSelection={this.updateUsernameFilter}
				tabIndex={1}
				hasSounds={true}
			/>
		);
	},

	renderCampusDropdown: function() {
		const {campus, academyOptions, academySortedOptionKeys} = this.state;
		return (
			<DropdownSelect
				className={styles.dropdown}
				initialValue={campus}
				options={academyOptions}
				customSortedOptionKeys={academySortedOptionKeys}
				updateSelection={this.updateCampus}
				tabIndex={1}
				hasSounds={true}
			/>
		);
	},

	renderLevelDropdown: function() {
		const {level} = this.state;
		return (
			<DropdownSelect
				className={styles.dropdown}
				initialValue={level}
				options={activeGradeOptions}
				orderOptions={"asc"}
				updateSelection={this.updateLevel}
				tabIndex={1}
				hasSounds={true}
			/>
		);
	},

	renderTimeWindowDropdown: function() {
		const {metric, timeWindow} = this.state;
		const timeWindows = metricTimeWindows[metric];
		const timeWindowDescriptions = {
			OneDay: "Yesterday",
			OneWeek: "Past 7 Days",
			OneMonth: "Past 30 Days",
			SixMonths: "Past 6 Months",
		};
		const timeWindowOptions = _.pick(timeWindowDescriptions, timeWindows);
		return (
			<DropdownSelect
				className={styles.dropdown}
				initialValue={timeWindow}
				options={timeWindowOptions}
				updateSelection={this.updateTimeWindow}
				tabIndex={1}
				hasSounds={true}
			/>
		);
	},

	render: function() {
		const {user, isAcademyUser} = this.props;
		const {
			usernameFilter,
			metric,
			timeWindow,
			level,
			campus,
			isMetricHelpModalOpen,
		} = this.state;
		let metricHelpModalEl = null;
		if (isMetricHelpModalOpen) {
			metricHelpModalEl = (
				<MessageModal
					styleType="default"
					levelType="aboveAll"
					size={"extra-large"}
					onClose={this.closeMetricHelpModal}
				>
					<LeaderboardsMetricHelpModal
						metric={metric}
						isAcademyUser={isAcademyUser}
					/>
				</MessageModal>
			);
		}

		const metricNavEl = this.renderMetricNavigator();
		const timeWindowDropdownEl = isAcademyUser
			? null
			: this.renderTimeWindowDropdown();
		const levelDropdownEl = isAcademyUser ? this.renderLevelDropdown() : null;
		const usernameFilterDropdownEl = isAcademyUser
			? null
			: this.renderUsernameFilterDropdown();
		const campusDropdownEl = isAcademyUser ? this.renderCampusDropdown() : null;

		return (
			<div>
				<Modal
					portalContainer={PORTAL_CONTAINERS.TRAINER_LEADERBOARD}
					onClose={this.onClose}
					closeOnBackdropClick={false}
					closeOnEsc={true}
					hasCloseButton={true}
					backdropClass={styles.backdrop}
					modalClass={styles.main}
					levelType="default"
				>
					<img
						className={styles.bg}
						src={AssetsUtil.getModal("leaderboards")}
					/>
					<div className={styles.contents}>
						<div className={styles.title}>
							<img
								src={AssetsUtil.getButton("leaderboards", "blue")}
								className={styles.leaderboardsIcon}
							/>
							<span>Leaderboards</span>
						</div>
						{metricNavEl}
						<div className={styles.dropdownContainer}>
							{timeWindowDropdownEl}
							{levelDropdownEl}
							{usernameFilterDropdownEl}
							{campusDropdownEl}
						</div>
						<ErrorBoundary
							onError={(error, info) => {
								ErrorUtil.log("E_REACT_CRASH", error, {
									componentStack: info.componentStack,
								});
							}}
							fallbackRender={({error}) => (
								<div className={styles.errorContainer}>
									<ReactPageTrainerError
										isReactCrash={true}
										inModal={true}
										outOfMemory={error && error.message === "out of memory"}
									/>
								</div>
							)}
						>
							<LeaderboardsRankings
								user={user}
								isAcademyUser={isAcademyUser}
								date={this.getCurrentLeaderboardsDate()}
								metric={metric}
								usernameFilter={usernameFilter}
								level={level}
								campus={campus}
								timeWindow={timeWindow}
							/>
						</ErrorBoundary>
					</div>
				</Modal>
				{metricHelpModalEl}
			</div>
		);
	},
});
